import { produce } from 'immer'
import BudgetOverviewReducer, {
  Actions as BudgetOverviewActions,
  BudgetOverviewState,
  initialState as initialBudgetOverviewState,
} from 'src/app/BudgetOverview/redux/budgetOverview.reducer'
import BudgetTransactionsReducer, {
  Actions as BudgetTransactionsActions,
  BudgetTransactionsState,
  initialState as initialBudgetTransactionsState,
} from 'src/app/BudgetTransactions/redux/budgetTransactions.reducer'
import BudgetVirtualCardsReducer, {
  Actions as BudgetVirtualCardsActions,
  BudgetVirtualCardsState,
  initialState as initialBudgetVirtualCardsState,
} from 'src/app/BudgetVirtualCards/redux/budgetVirtualCards.reducer'
import {
  GET_CREDIT_CARD_FAILURE,
  GET_CREDIT_CARD_INIT,
  GET_CREDIT_CARD_SUCCESS,
  GET_PARENT_CREDIT_CARD_FAILURE,
  GET_PARENT_CREDIT_CARD_INIT,
  GET_PARENT_CREDIT_CARD_SUCCESS,
  GetCreditCardActions,
  GetParentCreditCardActions,
} from 'src/redux/actions/data/creditCards.actions'

export interface BudgetBaseState {
  fetchingCreditCard: boolean
  fetchingParentCreditCard: boolean
}
export const initialBaseState: BudgetBaseState = {
  fetchingCreditCard: false,
  fetchingParentCreditCard: false,
}

export type BaseActions = GetCreditCardActions | GetParentCreditCardActions

const BaseBudgetReducer = (
  state = initialBaseState,
  action: BaseActions,
): BudgetBaseState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_CREDIT_CARD_INIT: {
        draft.fetchingCreditCard = true
        return draft
      }

      case GET_PARENT_CREDIT_CARD_INIT: {
        draft.fetchingParentCreditCard = true
        return draft
      }

      case GET_CREDIT_CARD_SUCCESS: {
        draft.fetchingCreditCard = false
        return draft
      }

      case GET_PARENT_CREDIT_CARD_SUCCESS: {
        draft.fetchingCreditCard = false
        return draft
      }

      case GET_CREDIT_CARD_FAILURE: {
        draft.fetchingCreditCard = false
        return draft
      }

      case GET_PARENT_CREDIT_CARD_FAILURE: {
        draft.fetchingCreditCard = false
        return draft
      }
    }
  })
}

export type BudgetState = BudgetBaseState & {
  budgetTransactions: BudgetTransactionsState
  budgetOverview: BudgetOverviewState
  budgetVirtualCards: BudgetVirtualCardsState
}

export const initialState: BudgetState = {
  ...initialBaseState,
  budgetTransactions: initialBudgetTransactionsState,
  budgetOverview: initialBudgetOverviewState,
  budgetVirtualCards: initialBudgetVirtualCardsState,
}

export type Actions =
  | BaseActions
  | BudgetTransactionsActions
  | BudgetOverviewActions
  | BudgetVirtualCardsActions

const BudgetReducer = (state = initialState, action: Actions): BudgetState => ({
  ...BaseBudgetReducer(state, action as BaseActions),
  budgetTransactions: BudgetTransactionsReducer(
    state.budgetTransactions,
    action as BudgetTransactionsActions,
  ),
  budgetOverview: BudgetOverviewReducer(
    state.budgetOverview,
    action as BudgetOverviewActions,
  ),
  budgetVirtualCards: BudgetVirtualCardsReducer(
    state.budgetVirtualCards,
    action as BudgetVirtualCardsActions,
  ),
})

export default BudgetReducer
